import { render, staticRenderFns } from "./template-card.vue?vue&type=template&id=1c5ceb5e&scoped=true&"
import script from "./template-card.vue?vue&type=script&lang=js&"
export * from "./template-card.vue?vue&type=script&lang=js&"
import style0 from "./template-card.vue?vue&type=style&index=0&id=1c5ceb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ceb5e",
  null
  
)

export default component.exports